// live时间段配置
export const live_time_options = {
    'qkld': {
        start: '19:00:00',
        end: '19:50:00',
        recover: '15:00:00',
        title: '乾坤论道',
        program_title: '乾坤论道'
    },
    'man_jgcl': {
        start: '19:00:00',
        end: '19:50:00',
        recover: '15:00:00',
        title: '机构策略',
        program_title: '机构策略男'
    },
    'gdyt': {
        start: '19:00:00',
        end: '19:50:00',
        recover: '15:00:00',
        title: '股道杨谈',
        program_title: '股道杨谈'
    },
    'cpsxlyg': {
        start: '15:30:00',
        end: '16:30:00',
        recover: '15:00:00',
        title: '操盘手训练营',
        program_title: '操盘手训练营一部'
    },
    'cpsxlyy': {
        start: '15:30:00',
        end: '16:30:00',
        recover: '15:00:00',
        title: '操盘手训练营',
        program_title: '操盘手训练营二部'
    },
    'pzzb': {
        title: '盘中直播',
        program_title: '盘中直播'
    },
    'pzzbv2': {
        title: '盘中直播',
        program_title: '盘中直播',
        recover: '09:30:00'
    },
    'sczj': {
        title: '市场直击',
        program_title: '市场直击'
    },
    'sczjv2': {
        title: '市场直击',
        program_title: '市场直击',
        recover: '09:30:00'
    },
    'cssj': {
        title: '财神时间',
        program_title: '财神 时间',
        recover: '18:30:00'
    },
    'cqzs': {
        start: '19:00:00',
        end: '19:50:00',
        recover: '15:00:00',
        title: '出奇制胜',
        program_title: '出奇制胜营销版',
    },
    'cqzsv2': {
        start: '19:00:00',
        end: '19:50:00',
        recover: '15:00:00',
        title: '出奇制胜',
        program_title: '出奇制胜纯净版',
    },
    'yzkpq': {
        start: '09:10:00',
        end: '09:25:00',
        recover: '00:00:01',
        title: '赢在开盘前',
        program_title: '赢在开盘前亚奇版',
    }
}

// 获取channelid 用于聊天室ws
export const getChannelId = sign => {
    const _env = process.env.VUE_APP_ENV
    const _channelid = {
        _production: {
            qkld: 3000001,
            man_jgcl: 3000000,
            gdyt: 3000000,
            pzzb: 3000005,
            pzzbv2: 3000005,
            sczj: 3000005,
            sczjv2: 3000005,
            cssj: 3000010,
            cpsxlyg: 3000013,
            cpsxlyy: 3000012
        },
        _pre: {
            qkld: 31,
            man_jgcl: 30,
            gdyt: 30,
            pzzb: 35,
            pzzbv2: 35,
            sczj: 35,
            sczjv2: 35,
            cssj: 39,
            cpsxlyg: 43,
            cpsxlyy: 42
        },
        _test: {   // test & local
            qkld: 131,
            man_jgcl: 130,
            gdyt: 130,
            pzzb: 135,
            pzzbv2: 135,
            sczj: 135,
            sczjv2: 135,
            cssj: 144,
            cpsxlyg: 149,
            cpsxlyy: 148
        },
    }
    return _channelid[`_${_env}`][sign] || null
}